import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as required from '../../required-validators';
import {fourDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';

const FieldDefinitionSI = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    validate: [required.postCode, fourDigitsPostcodeValidator],
  },
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  townCity,
  county,
];

export default FieldDefinitionSI;
